import {
  useGetAssessmentPathQuery,
  useGetOnboardingProfileQuery,
  type AssessmentPath,
} from '../store/api/onboardingApi';

/**
 * The active assessment path for a screen rendered inside OnboardingGuard.
 *
 * Read from the guard's GET /onboarding/me?include=path cache entry, so it
 * costs no request of its own. Only if that read failed, or the server did not
 * honour the include (no `path` key), does it fall back to
 * GET /onboarding/me/path.
 *
 * `undefined` = not known yet; `null` = no active path.
 */
export function useOnboardingPath(): AssessmentPath | null | undefined {
  const onboarding = useGetOnboardingProfileQuery();
  const data = onboarding.data;
  const included = data !== undefined && data !== null && 'path' in data;
  const needFallback = onboarding.isError || (data !== undefined && !included);
  const fallback = useGetAssessmentPathQuery(undefined, { skip: !needFallback });
  return included ? data.path ?? null : fallback.data;
}
